<template>
  <div>
    <v-card
      @click="
        $router.push(
          '/client/Form/' + item.nombre + '/' + item.region + '/' + item.id
        )
      "
      class="mx-auto rounded-0 "
      :disabled="item.semaforos ? item.semaforos.length == 0 : true"
      max-width="450"
    >
      <v-img :src="host + item.imgURI" height="200px"></v-img>
      <v-card-title
        class="location-name"
        color="primary"
        v-text="item.nombre"
      />
      <v-card-subtitle>
        <v-icon left v-text="'mdi-map-marker-outline'" />{{ item.region }}
        <br /><br />
        <div
          v-for="(avaible, index) in item.semaforos"
          :key="index"
          class="text-align"
        >
          <v-row>
            <v-col cols="1" style="padding:10px">
              <div :style="circleColor(avaible.semaforo)" class="circle" />
            </v-col>
            <v-col cols="10" style="padding:5px">
              {{ avaible.lugarTrabajo }}
            </v-col>
          </v-row>
        </div>
        <br />

        <br />
        <v-btn
          :disabled="item.semaforos ? item.semaforos.length == 0 : true"
          small
          block
          class="rounded-0"
          color="primary"
          >Reservar
        </v-btn>
      </v-card-subtitle>
      <v-card-text> </v-card-text>
    </v-card>
    <br />
  </div>
</template>

<script>
const props = {
  item: {
    type: Object,
    default: function() {
      return {};
    },
  },
};

export default {
  data: () => ({
    host: process.env.VUE_APP_API_SERVER,
  }),
  methods: {
    circleColor(type) {
      let color = "red";
      if (type == 1) {
        color = "#73d107";
      }
      if (type == 2) {
        color = "yellow";
      }
      return "background: " + color;
    },
  },
  props: props,
};
</script>

<style scoped>
.circle {
  width: 10px;
  height: 10px;
  border-radius: 100000000000px;
  padding: 0px !important;
  margin: 0px;
  vertical-align: middle !important;
}
.text-align {
  color: #707070;
  opacity: 1;
}
.location-name {
  color: #005591;
}
</style>
